<template><section><template>
<h3>级联选择</h3>
<div class="bs-docs-section">
  <div class="bs-example">
    <n3-cascader :options="options" :on-change="selectChange" v-model="value" :select-change="true"></n3-cascader>
  </div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-cascader</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"selectChange"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">:select-change</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-cascader</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">  [{
    <span class="hljs-attr">value</span>: <span class="hljs-string">'zhejiang'</span>,
    <span class="hljs-attr">label</span>: <span class="hljs-string">'浙江'</span>,
    <span class="hljs-attr">children</span>: [{
      <span class="hljs-attr">value</span>: <span class="hljs-string">'hangzhou'</span>,
      <span class="hljs-attr">label</span>: <span class="hljs-string">'杭州'</span>,
      <span class="hljs-attr">children</span>: [{
        <span class="hljs-attr">value</span>: <span class="hljs-string">'xihu'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'西湖'</span>,
      }],
    }],
  }, {
    <span class="hljs-attr">value</span>: <span class="hljs-string">'jiangsu'</span>,
    <span class="hljs-attr">label</span>: <span class="hljs-string">'江苏'</span>,
    <span class="hljs-attr">disabled</span>:<span class="hljs-literal">true</span>,
    <span class="hljs-attr">children</span>: [{
      <span class="hljs-attr">value</span>: <span class="hljs-string">'nanjing'</span>,
      <span class="hljs-attr">label</span>: <span class="hljs-string">'南京'</span>,
      <span class="hljs-attr">children</span>: [{
        <span class="hljs-attr">value</span>: <span class="hljs-string">'zhonghuamen'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'中华门'</span>,
      }],
    }],
  }]
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>options</td>
<td>Array</td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">200px</code></td>
<td>宽度</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>禁用</td>
</tr>
<tr>
<td>placeholder</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>display-render</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>select-change</td>
<td><code v-pre="">Boolean</code></td>
<td>-</td>
<td>选择值就改变</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>值变化时</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>
const options = [{
  value: 'zhejiang',
  label: '浙江',
  children: [{
    value: 'hangzhou',
    label: '杭州',
    children: [{
      value: 'xihu',
      label: '西湖'
    }]
  }]
}, {
  value: 'jiangsu',
  label: '江苏',
  disabled: true,
  children: [{
    value: 'nanjing',
    label: '南京',
    children: [{
      value: 'zhonghuamen',
      label: '中华门'
    }]
  }]
}]

const value = ['zhejiang', 'hangzhou']

export default {
  data () {
    return {
      options: options,
      value: value
    }
  },
  methods: {
    selectChange (selectedValue) {
      console.log(this.value)
    }
  },
  mounted() {
    setTimeout(()=>{
      this.value = ['zhejiang']
    },1000)
  }
}
</script>


// WEBPACK FOOTER //
// n3CascaderDocs.md?db0973a4